import React from 'react';
import { useTranslation } from 'react-i18next';

import { LinkBlank } from '@mssgme/ui';
import styles from './styles.scss';

export const LegaliseSection = () => {
    const { t } = useTranslation('auth');

    return (
        <span className={styles.terms}>
            {t('auth.signup.termsText')}{' '}
            <LinkBlank href="https://mssg.me/privacy-policy">{t('auth.signup.policy')}</LinkBlank>{' '}
            {t('auth.signup.and')} <LinkBlank href="https://mssg.me/terms-of-use">{t('auth.signup.terms')}</LinkBlank>
        </span>
    );
};
